var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      staticStyle: { top: "15%", height: "70%", "overflow-y": "hidden" },
      attrs: {
        title: _vm.title,
        width: _vm.modalWidth,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
        cancelText: "关闭",
      },
      on: { cancel: _vm.handleCancel },
    },
    [
      _c(
        "template",
        { slot: "footer" },
        [
          _c("a-button", { key: "back", on: { click: _vm.handleCancel } }, [
            _vm._v("\n      关闭\n    "),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-page-search-wrapper" },
        [
          _c(
            "a-form",
            {
              attrs: { layout: "inline" },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.searchQuery.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "标题" } },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入标题" },
                            model: {
                              value: _vm.queryParam.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParam, "name", $$v)
                              },
                              expression: "queryParam.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("a-col", { attrs: { span: 12 } }, [
                    _c(
                      "span",
                      {
                        staticClass: "table-page-search-submitButtons",
                        staticStyle: { float: "left", overflow: "hidden" },
                      },
                      [
                        _c(
                          "a-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.searchQuery },
                          },
                          [_vm._v("查询")]
                        ),
                        _c(
                          "a-button",
                          {
                            staticStyle: { "margin-left": "8px" },
                            on: { click: _vm.searchReset },
                          },
                          [_vm._v("重置")]
                        ),
                        _c(
                          "a-button",
                          {
                            staticStyle: { "margin-left": "8px" },
                            attrs: { type: "primary", icon: "book" },
                            on: { click: _vm.readAll },
                          },
                          [_vm._v("全部标注已读")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { "margin-top": "5px" } },
        [
          _c("a-table", {
            ref: "table",
            attrs: {
              size: "default",
              bordered: "",
              rowKey: "id",
              columns: _vm.columns,
              dataSource: _vm.dataSource,
              pagination: _vm.ipagination,
              loading: _vm.loading,
            },
            on: { change: _vm.handleTableChange },
            scopedSlots: _vm._u([
              {
                key: "customRenderTitle",
                fn: function (text, record) {
                  return [
                    record.status == "1"
                      ? _c("span", { staticStyle: { "font-weight": "bold" } }, [
                          _vm._v(_vm._s(text)),
                        ])
                      : _vm._e(),
                    record.status == "2"
                      ? _c("span", [_vm._v(_vm._s(text))])
                      : _vm._e(),
                  ]
                },
              },
              {
                key: "action",
                fn: function (text, record) {
                  return _c("span", {}, [
                    _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.showAnnouncement(record)
                          },
                        },
                      },
                      [_vm._v("查看")]
                    ),
                  ])
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("show-announcement", { ref: "ShowAnnouncement" }),
      _c("dynamic-notice", {
        ref: "showDynamNotice",
        attrs: { path: _vm.openPath, formData: _vm.formData },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }